import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { LPpages } from "../../Helpers/LPpages";

const Whychooseus = ({ data }) => {

  const location = useLocation();
  const LPpage = LPpages.includes(location.pathname);
  // Default old data (kept as is)
  const defaultData = [
    {
      whyChooseImg: "../assests/images/oldwhyChoose1.svg",
      whyChooseHeading: "Customization",
    },
    {
      whyChooseImg: "../assests/images/oldwhyChoose2.svg",
      whyChooseHeading: "Dedicated Support",
    },
    {
      whyChooseImg: "../assests/images/oldwhyChoose3.svg",
      whyChooseHeading: "Timely Delivery",
    },
    {
      whyChooseImg: "../assests/images/whyChoose (4).svg",
      whyChooseHeading: "Wide Selection",
    },
  ];

  // If data is passed → use it, else use default
  const whyChooseData = data || defaultData;

  return (
    <>
      <div className="bgeYantra py-5 m-0 px-0">
        <Container>
          <h2 className="text-center py-3 fs-32">Why Choose eYantra? </h2>

          <Row>
            {whyChooseData.map((item, index) => (
              <Col md={3} className="col-6 mt-1" key={index}>
                <div className="border border-1 rounded-5">
                  <img
                    src={item.whyChooseImg}
                    className="img-fluid rounded-top-5"
                    width="100%"
                    loading="lazy"
                    alt={item.whyChooseHeading}
                  />
                  <p
                    className="text-white py-3 my-0 rounded-bottom-5 text-center fs-14"
                    id="subMenuBg"
                  >
                    {item.whyChooseHeading}
                  </p>
                </div>
              </Col>
            ))}
          </Row>

          <p className="w-75 text-center m-auto my-3 fs-16 d-md-block d-none">
            With years of expertise in branded merchandise, eYantra is your
            partner in creating gifts that go beyond transactional value. We
            combine creativity, quality, and precision to deliver solutions that
            engage, inspire, and endure.
          </p>

          <p className="w-100 text-center m-auto my-3 fs-16 d-md-none d-block">
            With years of expertise in branded merchandise, eYantra is your
            partner in creating gifts that go beyond transactional value. We
            combine creativity, quality, and precision to deliver solutions that
            engage, inspire, and endure.
          </p>

          <h2 className="text-center fw-bold" id="subHeading">
            Ready to elevate your brand?
          </h2>
          { LPpage ? (
          <a href="#contact-form" className="text-decoration-none">
                                <Button id="btnCTA" className="m-auto d-block mt-4 mb-4">
                                Get a Quote
                                </Button>
                            </a>
            ) :        

          <Link to="/contact-us" className="text-decoration-none">
            <Button id="btnCTA" className="m-auto d-block px-5 rounded-5 my-3">
              Get a Quote
            </Button>
          </Link>
          }

          <p className="text-center w-100 d-block m-auto">
            Let us help you craft unforgettable experiences for employees,
            <br />
            clients, event attendees, and more.
          </p>
        </Container>
      </div>
    </>
  );
};

export default Whychooseus;
